import React, { useCallback, useState, useEffect } from 'react'

import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import AccountDisplay from '../../components/account-display/account-display'
import BeneficiaryDisplay from '../../components/beneficiary-display/beneficiary-display'

import NeoButton from '../../components/NeoButton/NeoButton'
import { Formik, Form, Field } from 'formik'
import NeoInput from '../../components/NeoInput/NeoInput'
import InputError from '../../components/InputError/InputError'
import NeoSuccess from '../../components/FormComponents/NeoSuccess'
import NeoOTP from '../../components/FormComponents/NeoOTP'
import Loading from 'custom/assets/loaders/Loading'
import TermsAndCondition from '../../components/TermsAndConditions/TermsAndCondition'
import { getCurrentAccDetailsSelector, getRoleAccessKeySelector } from '../../store/selectors/app.selector'
import {  InternationalTransferSchema } from '../../schemas/transfers'
import LayoutWithAccountCard from '../Layout/layout-account-card'
import TransferService from '../../services/transfer.service'
import { setIsAcctRefresh } from '../../store/actions/app.actions'

import moment from 'moment'
import {
  BUTTON_KEYS,
  BENEFICIARY_TRANSFER_KEYS,
  VALIDATION_KEYS,
} from '../../utils/translation-constants'
import { useTranslation } from 'react-i18next'
import validationConfig from 'custom/config/validation.config.json'
import NumberFormat from 'react-number-format'
import config from "custom/config/environment"
import QuickLinkService from '../../services/quick-link.service'
const internationalTransferConfig = validationConfig['transfers']['international']

export default function InternationalAccountTransfer() {
  const dispatch = useDispatch()
  const history = useHistory()
  const location = useLocation()
  const [message, setMessage] = useState('')
  const [loading, setLoading] = useState(false)
  const [stage, setStage] = useState(1)
  const [otp, setOtp] = useState('')
  const [otpEnabled, setOtpEnabled] = useState(false)
  const [beneDetails, setBeneDetails] = useState({})
  const [formValues, setFormValues] = useState({})
  const [verifyDetails, setVerifyDetails] = useState({})
  const [transferType, setTransferType] = useState({})
  const [currencyList, setCurrencyList] = useState([])
  const currentAccountDetail = useSelector(getCurrentAccDetailsSelector)
  const [selectedModeOfTransfer, setSelectedModeOfTransfer] = useState('Y')
  const [requestDetails, setRequestDetails] = useState({})
  const accessKey = useSelector(getRoleAccessKeySelector)
  const [successResponse, setSuccessResponse] = useState({})

  const { t } = useTranslation()


  useEffect(() => {
    if (location.state === undefined) {
      history.push('/transfers')
      return
    }
    console.log(location?.state)
    setBeneDetails(location?.state?.beneDetails)
    setTransferType(location?.state?.transferType)
    fetchCurrencyList()
  }, [])

  const fetchCurrencyList = useCallback(async () => {
    const response = await TransferService.getSwiftCurrencies()
    if (response.status === 200) {
      setCurrencyList(response.data)
    }
  })

  const onVerify = useCallback(
    async (values) => {
      try {
        setLoading(true)
        setFormValues(values)
        if ((values.transferAmount === '0.00' || values.transferAmount === '.00') && values.isInvoice !== true) {
          return
        }

        const reqParams = {
          transferReq: {
            fin: {
              srcAccount: currentAccountDetail.accountNo,
              srcAccBranch: currentAccountDetail.brnCode,
              srcAccCcy: currentAccountDetail.currency,
              destAccount: beneDetails.beneAccNo,
              destAccBranch: beneDetails.beneBrn,
              destAccCcy: beneDetails.beneCurrency,
              destBankName: beneDetails.bankName,
              destBankCountry: beneDetails.bankCountry || '',
              destBankAddress: beneDetails.bankAddress,
              beneAddress: beneDetails.addrline,
              modeOfTransfer: '',
              amount: values.transferAmount,
              txnCurrency: values.txnCurrency,
              bicCode: beneDetails?.bicCode || '',
              sortCode: beneDetails?.sortCode || '',
              remarks: values.remarks,
              chargesBorneBy: '',
              txnDate: '',
            },
            nfin: {
              transferType: values.transferType,
              beneId: beneDetails.reqId,
              scheduled: values.isScheduled === 'Yes' ? true : false,
              scheduledDate: values.scheduledDate || '',
              beneficiaryName: beneDetails.beneName,
              beneficiaryMail: beneDetails.beneEMail,
              beneficiaryMobile: beneDetails.beneMobileNo,
              addBeneficiary: false,
              bulkTransfer: false,
            },
            cdf: {
              fxRefNo: values.hasFxRefNo === 'Y' ? values.fxRefNo : '',
            },
          },
        }
        const response = await TransferService.externalVerifyFundTransfer(reqParams)
        if (response.status === 200) {
          setOtpEnabled(response.data['otpEnable'])
          setVerifyDetails(response.data)
          setRequestDetails(reqParams)
          setStage(2)
          setLoading(false)
        }
      } catch (err) {
        setLoading(false)
        setMessage(err?.data)
        //showModal()
      }
    },
    [beneDetails, transferType, currentAccountDetail, currencyList],
  )

  const onConfirm = useCallback(async () => {
    try {
      setLoading(true)
      const reqParams = {
        ...requestDetails,
        otp: otp || '0000',
        randomKey: verifyDetails.randomKey,
      }

      const response = await TransferService.externalInitiateTransfer(reqParams)
      if (response.status === 200) {
        dispatch(setIsAcctRefresh(true))
        setSuccessResponse(response.data)
        setMessage(response.data['message'])
        setStage(4)
        setLoading(false)
      }
    } catch (err) {
      setMessage(err?.data)
      setOtp('')
      //showModal()
      setLoading(false)
    }
  }, [otp, verifyDetails, requestDetails])

  function renderSwitch() {
    switch (stage) {
      case 1:
        return renderForm()
      case 2:
        return renderConfirm()
      case 3:
        return <NeoOTP otp={otp} setOTP={setOtp} onSubmit={onConfirm} loading={loading} />
      case 4:
        return <NeoSuccess 
        onClick1={async () =>
          await QuickLinkService.pdfReceipt({
            transRefNum: successResponse.referenceNo,
            refId: '',
            module: 'FUNDTRANSFER',
          })}
        module='DOWNLOAD_RECEIPT'
        roleKey={accessKey}
        message={message} 
        linkPath='/transfers' />
      default:
        return renderForm()
    }
  }

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  function renderForm() {
    return (
      <>
        <AccountDisplay currentAccountDetail={currentAccountDetail} />
        <p style={{ fontSize: 10, fontWeight: 600, paddingLeft: 30 }}>To</p>
        <BeneficiaryDisplay beneDetails={beneDetails} />
        <Formik
          initialValues={{
            transferAmount: '',
            remarks: '',
            txnCurrency: '',
            transferType: 'SWIFT',
            // beneAlert: 'All',
            hasFxRefNo: 'N',
            // senderToReceiverInfo: '',
            fxRefNo: '',
            //  customRemarks: '',
            // chargeBearer: chargesList[0].name,
            // isInvoice: true,
            // uploadFile: '',
            isScheduled: 'No',
            scheduledDate: '',
          }}
          enableReinitialize
          validationSchema={InternationalTransferSchema}
          onSubmit={onVerify}>
          {({ isSubmitting, errors, touched, setFieldValue, handleChange, values }) => (
            <Form>
              <div>
                <label style={{ display: 'block' }} className='control-label'>
                  {t(BENEFICIARY_TRANSFER_KEYS.TRANSFER_TYPE)}
                </label>
                <div className='custom-control custom-radio custom-control-inline pt-20'>
                  <Field
                    as='input'
                    type='radio'
                    id='transferTypeSelect1'
                    name='transferType'
                    value='SWIFT'
                    className='custom-control-input'
                  />
                  <label className='custom-control-label' htmlFor='transferTypeSelect1'>
                    {t(BENEFICIARY_TRANSFER_KEYS.SWIFT)}
                  </label>
                </div>
              </div>

              <div className='form-group'>
                <NeoInput
                  tabIndex={'1'}
                  text={t(BENEFICIARY_TRANSFER_KEYS.TRANSFER_AMOUNT)}
                  name='amount'
                  onChange={(values) => {
                    setFieldValue('transferAmount', values.value)
                  }}
                  mode='amount'
                />
                <InputError text={errors.transferAmount} touched={touched.transferAmount} />
                <InputError
                  text={t(VALIDATION_KEYS.TRANSFER_AMOUNT_VALIDATION)}
                  touched={values.transferAmount === '0.00' || values.transferAmount === '.00'}
                />
              </div>

              {/* <div className='mt-3 form-group'>
                <NeoInput
                  showAsterisk={internationalTransferConfig['isBeneAlertRequired']}
                  text={t(BENEFICIARY_TRANSFER_KEYS.BANK_ALERT)}
                  mode='select'
                  name='beneAlert'
                  onChange={(e) => {
                    handleChange(e)
                  }}
                  list={smsAlertList}
                  keyValue={'label'}
                />
                <InputError text={errors.beneAlert} touched={touched.beneAlert} />
              </div> */}

              <div className='mt-3 form-group'>
                <NeoInput
                  tabIndex={'2'}
                  showAsterisk={internationalTransferConfig['isCurrencyRequired']}
                  text={t(BENEFICIARY_TRANSFER_KEYS.CURRENCY)}
                  mode='select'
                  name='txnCurrency'
                  onChange={(e) => {
                    handleChange(e)
                  }}
                  list={currencyList}
                  keyValue={'currencyCode'}
                />
                <InputError text={errors.txnCurrency} touched={touched.txnCurrency} />
              </div>

              {/* <div className='form-group'>
                <NeoInput
                  showAsterisk={internationalTransferConfig['isSenderInfoRequired']}
                  text={t(BENEFICIARY_TRANSFER_KEYS.SENDER_TO_RECEIVER)}
                  name='senderToReceiverInfo'
                  onChange={handleChange}
                />

                <InputError
                  text={errors.senderToReceiverInfo}
                  touched={touched.senderToReceiverInfo}
                />
              </div> */}
              
                <div style={{ marginTop: 20 }}>
                {internationalTransferConfig['isHasFxNoRequired'] &&
                  (<><div className='custom-control custom-radio custom-control-inline pt-20'>
                    <h5>{t(BENEFICIARY_TRANSFER_KEYS.HAS_FX_DEAL)} ?</h5>
                  </div>

                    <div className='custom-control custom-radio custom-control-inline pt-20'>
                      <Field
                        tabIndex={'3'}
                        as='input'
                        type='radio'
                        id='transferTypeSelect3'
                        name='hasFxRefNo'
                        value='Y'
                        onChange={(text) => {
                          handleChange(text)
                          setSelectedModeOfTransfer(text.target.value)
                        }}
                        className='custom-control-input'
                      />
                      <label className='custom-control-label' htmlFor='transferTypeSelect3'>
                        {t(BENEFICIARY_TRANSFER_KEYS.YES)}
                      </label>
                    </div>

                    <div className='custom-control custom-radio custom-control-inline'>
                      <Field
                        tabIndex={'4'}
                        as='input'
                        type='radio'
                        id='transferTypeSelect2'
                        name='hasFxRefNo'
                        value='N'
                        onChange={(text) => {
                          handleChange(text)
                          setSelectedModeOfTransfer(text.target.value)
                        }}
                        className='custom-control-input'
                      />
                      <label className='custom-control-label' htmlFor='transferTypeSelect2'>
                        {t(BENEFICIARY_TRANSFER_KEYS.NO)}
                      </label>
                    </div></>)
                }

                {values.hasFxRefNo === 'Y' && (
                  <>
                    <NeoInput
                      tabIndex={'5'}
                      text={t(BENEFICIARY_TRANSFER_KEYS.FX_REF_NO)}
                      showAsterisk={internationalTransferConfig['isFxRefRequired']}
                      name='fxRefNo'
                      onChange={handleChange}
                    />
                    <InputError text={errors.fxRefNo} touched={touched.fxRefNo} />
                  </>
                )}
              </div>

              {/* <div className='form-group'>
                <div class='form-check'>
                  <Field
                    as='input'
                    id='invoice'
                    type='checkbox'
                    className='form-check-input'
                    name='isInvoice'
                    onChange={(e) => {
                      handleChange(e)
                      console.log(e.target.checked)
                      e.target.checked === false
                        ? setIsUploadVisible(false)
                        : setIsUploadVisible(true)
                    }}
                  />
                  <label className='font-weight-bold' htmlFor='invoice'>
                    {t(BENEFICIARY_TRANSFER_KEYS.INVOICE_SUBMIT)}
                  </label>
                </div>
                {isUploadVisible && (
                  <>
                    <Upload customRequest={handleAction} onChange={handleUpload}>
                      <Button className='upload-btn'>{t(BENEFICIARY_TRANSFER_KEYS.CHOOSE_FILE)}</Button>
                    </Upload>
                  </>
                )}
              </div> */}

              {/* <div className='mt-3 form-group'>
                <NeoInput
                 showAsterisk={internationalTransferConfig['isChargeBearerRequired']}
                  text={t(BENEFICIARY_TRANSFER_KEYS.CHARGE_BEARER)}
                  mode='select'
                  name='chargeBearer'
                  onChange={(e) => {
                    handleChange(e)
                  }}
                  list={chargesList}
                  keyValue={'name'}
                />
                <InputError text={errors.chargeBearer} touched={touched.chargeBearer} />
              </div> */}
              {config.SCHEDULED_TRANSFERS &&
                <>
                  <div className='mt-3 form-group'>
                    <NeoInput
                      tabIndex={'6'}
                      showAsterisk={internationalTransferConfig['isSchedulePaymentRequired']}
                      text={t(BENEFICIARY_TRANSFER_KEYS.SCHEDULED_PAYMENT)}
                      mode='select'
                      name='isScheduled'
                      onChange={(e) => {
                        handleChange(e)
                      }}
                      list={['Yes', 'No']}
                      keyValue={null}
                    />
                    <InputError text={errors.isScheduled} touched={touched.isScheduled} />
                  </div>

                  {values.isScheduled === 'Yes' && (
                    <div className='form-group mt-3'>
                      <NeoInput
                        tabIndex={'7'}
                        name='scheduledDate'
                        showAsterisk={internationalTransferConfig['isScheduleDateRequired']}
                        text={t(BENEFICIARY_TRANSFER_KEYS.SCHEDULED_DATE)}
                        icon='calendar_today'
                        mode='single'
                        type='date'
                        onChange={handleChange}
                        min={moment(new Date()).format('YYYY-MM-DD')}
                      />
                      <InputError text={errors.scheduledDate} touched={touched.scheduledDate} />
                    </div>
                  )}
                </>
              }

              <div className='mt-3 form-group'>
                <NeoInput
                  tabIndex={'8'}
                  text={t(BENEFICIARY_TRANSFER_KEYS.REMARKS)}
                  showAsterisk={internationalTransferConfig['isRemarksRequired']}
                  onChange={handleChange}
                  name='remarks'
                />
                <InputError text={errors.remarks} touched={touched.remarks} />
              </div>
              <div></div>
              <div className='mt-3'>
                {isSubmitting ? (
                  renderLoading()
                ) : (
                  <NeoButton
                    tabIndex={'9'}
                    type='submit'
                    mode={'newDesign'}
                    disabled={isSubmitting}
                    text={t(BUTTON_KEYS.SUBMIT)}
                  />
                )}
              </div>
              <div className='back-cancel-btn-container'>
              <button tabIndex={'10'} className='back-cancel-btn btn btn-sm new-design-warning-text-color' onClick={() => history.goBack()}>
                {t(BUTTON_KEYS.CANCEL)}
              </button>
              </div>
            </Form>
          )}
        </Formik>
      </>
    )
  }

  function renderConfirm() {
    return (
      <>
        <AccountDisplay currentAccountDetail={currentAccountDetail} />
        <p style={{ fontSize: 10, fontWeight: 600, paddingLeft: 30 }}>To</p>
        <BeneficiaryDisplay beneDetails={beneDetails} />
        <div className='d-flex flex-column confirmation'>
          <div>
            <h6 className='label'>{t(BENEFICIARY_TRANSFER_KEYS.TRANSFER_TYPE)}</h6>
            <h6 className='value'>{formValues?.transferType}</h6>
          </div>
          <div>
            <h6 className='label'>{t(BENEFICIARY_TRANSFER_KEYS.TRANSFER_AMOUNT)}</h6>
            <h6 className='value'>{formValues?.transferAmount}</h6>
          </div>

          <div>
            <h6 className='label'>{t(BENEFICIARY_TRANSFER_KEYS.CHARGES)}</h6>
            <h6 className='value'>
              <NumberFormat
                value={verifyDetails?.charges || 0}
                displayType={'text'}
                thousandSeparator={true}
                prefix={''}
                fixedDecimalScale={true}
                decimalScale={2}
                allowEmptyFormatting
              />
            </h6>
          </div>

          <div>
            <h6 className='label'>{t(BENEFICIARY_TRANSFER_KEYS.CURRENCY)}</h6>
            <h6 className='value'>{formValues.txnCurrency}</h6>
          </div>

          {/* <div>
            <h6 className='label'>{t(BENEFICIARY_TRANSFER_KEYS.CHARGE_BEARER)}</h6>
            <h6 className='value'>{formValues?.chargeBearer}</h6>
          </div> */}

          {internationalTransferConfig['isHasFxNoRequired'] &&
            <div>
              <h6 className='label'>{t(BENEFICIARY_TRANSFER_KEYS.HAS_FX_DEAL)} </h6>
              <h6 className='value'>{formValues.hasFxRefNo === 'N' ? 'No' : 'Yes'}</h6>
            </div>
          }
          {formValues.hasFxRefNo === 'Y' && (
            <div>
              <h6 className='label'>{t(BENEFICIARY_TRANSFER_KEYS.FX_REF_NO)}</h6>
              <h6 className='value'>{formValues.fxRefNo}</h6>
            </div>
          )}

          {/* <div>
            <h6 className='label'>{t(BENEFICIARY_TRANSFER_KEYS.SENDER_TO_RECEIVER)}</h6>
            <h6 className='value'>{formValues.senderToReceiverInfo}</h6>
          </div> */}
          {config.SCHEDULED_TRANSFERS &&
            <>
              <div>
                <h6 className='label'>{t(BENEFICIARY_TRANSFER_KEYS.SCHEDULED_PAYMENT)}</h6>
                <h6 className='value'>{formValues?.isScheduled}</h6>
              </div>
              {formValues.isScheduled === 'Yes' && (
                <div>
                  <h6 className='label'>{t(BENEFICIARY_TRANSFER_KEYS.SCHEDULED_DATE)}</h6>
                  <h6 className='value'>{moment(formValues.scheduledDate).format('DD-MM-YYYY')}</h6>
                </div>
              )}
            </>
          }

          <div>
            <h6 className='label'>{t(BENEFICIARY_TRANSFER_KEYS.REMARKS)}</h6>
            <h6 className='value'>
              {formValues.remarks === 'Custom' ? formValues.customRemarks : formValues.remarks}
            </h6>
          </div>

          <div>
            <TermsAndCondition module="BENEFICIARYTRANSFER" />
          </div>

          <div className='mt-3'>
            {loading ? (
              renderLoading()
            ) : (
              <NeoButton
                mode='newDesign'
                type='button'
                className='btn btn-neo'
                onClick={() => (otpEnabled ? setStage(3) : onConfirm())}
                text={t(BUTTON_KEYS.CONFIRM)}
              />
            )}
          </div>
          <div className='back-cancel-style' onClick={() => setStage(1)}>
            {t(BUTTON_KEYS.BACK)}
          </div>
        </div>
      </>
    )
  }

  return (
    <LayoutWithAccountCard breadCumKey='TRANSFER_INTERNATIONAL'>
      <div className='new-design-form-style'>
        <div className='heading-style'>{t(BENEFICIARY_TRANSFER_KEYS.TITLE_INTERNATIONAL)}</div>

        <div>{renderSwitch()}</div>
      </div>
    </LayoutWithAccountCard>
  )
}
